var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLearning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M0 0h14v14H0z"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.493.743c.662.158 1.295.42 1.875.777l1.218-.54 1.435 1.435-.54 1.217c.356.58.619 1.213.776 1.875l1.243.478v2.03l-1.243.479a6.4 6.4 0 0 1-.777 1.874l.541 1.218-1.435 1.435-1.218-.54c-.58.357-1.212.619-1.875.777L8.015 14.5h-2.03l-.478-1.243a6.4 6.4 0 0 1-1.875-.777l-1.218.541L.98 11.586l.54-1.218a6.4 6.4 0 0 1-.776-1.875L-.5 8.015v-2.03l1.243-.478a6.4 6.4 0 0 1 .777-1.875L.979 2.415 2.414.979l1.218.541A6.4 6.4 0 0 1 5.507.743L5.985-.5h2.03zM7.03 5.146l-3.304.878c-.092.024-.092.157 0 .181l3.304.878c.05.013.095.013.144 0l3.304-.878c.092-.024.092-.157 0-.181l-3.304-.878a.27.27 0 0 0-.144 0M3.359 7.58l-.068.04c-.07.04-.11.108-.11.189v.778c0 .077.089.121.15.075l.278-.209.277.209c.062.046.15.002.15-.075v-.778c0-.08-.04-.15-.109-.19l-.068-.039v-.821l-.262-.07a.6.6 0 0 1-.238-.123zm1.2-.635v1.357a.186.186 0 0 0 .154.184c2.798.517 1.979.517 4.776 0a.186.186 0 0 0 .154-.184V6.944l-2.341.622a.77.77 0 0 1-.401 0zM7 2.077a4.923 4.923 0 1 0 0 9.846 4.923 4.923 0 0 0 0-9.846",
  clipRule: "evenodd"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})))));
export { SvgLearning as ReactComponent };
export default __webpack_public_path__ + "static/media/learning.10adb0babdab458b00d9896765fa172f.svg";